import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { Variable } from '../../../models/formulas/variable';
import { findVariableCatalogAct, saveVariableCatalogAct, updateVariableCatalogAct } from '../../../store/variable-catalog/variable-catalog.action';

@Component({
  selector: 'app-variable-add',
  standalone: false,
  templateUrl: './variable-add.component.html',
  styleUrl: './variable-add.component.css'
})
export class VariableAddComponent {

  variableCatForm!: NgForm;
  loading = false;
  title!: string;
  variable: Variable = new Variable();
  violations: any;
  //variableTypes: VariableType[] = [];

  constructor(
    private route: ActivatedRoute,
    private variableStore: Store<{variableCatalogRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>
  ) {
    this.variableStore.pipe(
      select('variableCatalogRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        variable: state.variable,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ variable, violations, loading }) => {
      //this.variable = variable;
      this.variable = JSON.parse(JSON.stringify(variable));
      this.violations = violations;
      this.loading = loading;
      this.title = 'Detalles de Benefico';

      if(this.variableCatForm){
      
        Object.keys(this.variableCatForm.controls).forEach(controlName => {
          const control = this.variableCatForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

    /*this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        variableTypes: state.variableTypes
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ variableTypes }) => {
      //this.variableTypes = variableTypes;
      this.variableTypes = JSON.parse(JSON.stringify(variableTypes));
    });*/

  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.variableStore.dispatch(findVariableCatalogAct({ id }));
      }else{
        this.variable = new Variable();
        this.variable.active = true;
        this.loading = false;
        this.title = 'Agregar Beneficio';
      }
    });

    //this.catalogOfferStore.dispatch(findVariableCatalogAct());
  }

  onSubmitBenefir(variableCatForm: NgForm): void {
    //this.loading = true;
    this.variableCatForm = variableCatForm;
    const variableCopy = JSON.parse(JSON.stringify(this.variable));
   
    if (variableCopy.id > 0) {
      this.variableStore.dispatch(updateVariableCatalogAct({ variableUpdated: variableCopy }))
    } else {
      this.variableStore.dispatch(saveVariableCatalogAct({ variableNew: variableCopy }))
    }
  }

  compareVariableTypes = (a: any, b: any) => a?.id === b?.id;
  removeSpaces() {
    this.variable.attribute = (this.variable.attribute ?? '').replace(/\s+/g, '');
  }  
  
}
